// Removed — investor_onboarding_item endpoints no longer exist in backend
export function listInvestorOnboardingItems() {
  return () => {};
}

export function signInvestorOnboardingItem() {
  return () => {};
}
